import React from 'react';
import Hero from '../components/Hero';
import FeaturesBento from '../components/FeaturesBento';
import GovernancePreview from '../components/GovernancePreview';
import Audience from '../components/Audience';
import HowItWorks from '../components/HowItWorks';
import Benefits from '../components/Benefits';
import FinalCTA from '../components/FinalCTA';

const HomePage = () => (
  <>
    <Hero />
    <FeaturesBento />
    <GovernancePreview />
    <Audience />
    <HowItWorks />
    <Benefits />
    <FinalCTA />
  </>
);

export default HomePage;
